// extracted by mini-css-extract-plugin
module.exports = {"PageContainer":"PageContainer-module--PageContainer--15a8r","PageContent":"PageContainer-module--PageContent--1j-1r"};